// @flow
import type {Action} from '../../../state/types'

export type SetPlacePayload = {
  place: ?ServiceProvider,
}

const id = 'place/SET_PLACE'

export const setPlace = (place: ?ServiceProvider): Action<SetPlacePayload> => ({
  type: id,
  payload: {
    place,
  }
})

setPlace.id = id
